export const lastMatches = [
    {
        game: "League of Legeds",
        platform: "PC",
        player_a: {
            isWinner: true,
            name: "Player A",
            avatar: "/img/players/03.png",
            level: "Pro"
        },
        player_b: {
            isWinner: false,
            name: "Player B",
            avatar: "/img/players/01.png",
            level: "Explorer"
        }
    },
    {
        game: "Freefire",
        platform: "Móvil",
        player_a: {
            isWinner: true,
            name: "Player X",
            avatar: "/img/players/04.png",
            level: "Scout"
        },
        player_b: {
            isWinner: false,
            name: "Player B",
            avatar: "/img/players/02.png",
            level: "Explorer"
        }
    },
    {
        game: "Freefire",
        platform: "Móvil",
        player_a: {
            isWinner: false,
            name: "Player H",
            avatar: "/img/players/05.png",
            level: "Pro"
        },
        player_b: {
            isWinner: true,
            name: "Player C",
            avatar: "/img/players/06.png",
            level: "MVP"
        }
    },
    {
        game: "COD: Modern Warfare",
        platform: "PC",
        player_a: {
            isWinner: true,
            name: "Player A",
            avatar: "/img/players/03.png",
            level: "Pro"
        },
        player_b: {
            isWinner: false,
            name: "Player X",
            avatar: "/img/players/04.png",
            level: "Explorer"
        }
    }
]

export const TopGames = [
    {
        name: "League of Legends",
        platform: "PC",
        media: "/img/tg/pc/league-of-legends.jpg",
        metas: null
    },
    {
        name: "Counter Strike GO",
        platform: "PC",
        media: "/img/tg/pc/counter-strike-go.jpg",
        metas: null
    },
    {
        name: "COD MW Warzone",
        platform: "PC",
        media: "/img/tg/pc/cod-warzone.jpg",
        metas: null
    },
    {
        name: "Valorant",
        platform: "PC",
        media: "/img/tg/pc/valorant.jpg",
        metas: null
    },
    {
        name: "Dota 2",
        platform: "PC",
        media: "/img/tg/pc/dota-2.jpg",
        metas: null
    },
    {
        name: "Fortnite",
        platform: "PC",
        media: "/img/tg/pc/fornite.jpg",
        metas: null
    },
    {
        name: "Fifa",
        platform: "PC",
        media: "/img/tg/pc/fifa.jpg",
        metas: null
    },
    //Móvil
    {
        name: "Brawl Stars",
        platform: "Móvil",
        media: "/img/tg/mobile/brawl-stars.jpg",
        metas: null
    },
    {
        name: "Clash Royale",
        platform: "Móvil",
        media: "/img/tg/mobile/clash-royale.jpg",
        metas: null
    },
    {
        name: "Mobile Legends",
        platform: "Móvil",
        media: "/img/tg/mobile/mobile-legends.jpg",
        metas: null
    },
    {
        name: "COD Mobile",
        platform: "Móvil",
        media: "/img/tg/mobile/cod.jpg",
        metas: null
    },
    {
        name: "Free Fire",
        platform: "Móvil",
        media: "/img/tg/mobile/free-fire.jpg",
        metas: null
    },
    {
        name: "Arena of Valor",
        platform: "Móvil",
        media: "/img/tg/mobile/arena-of-valor.jpg",
        metas: null
    },
    {
        name: "Pubg Mobile",
        platform: "Móvil",
        media: "/img/tg/mobile/pubg.jpg",
        metas: null
    },
]

export const LastNews = [
    {
        title: "Week'nd Winners",
        category: "Evento",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-7.jpg",
        meta: "Diciembre 16, 2020"
    },
    {
        title: "Próximo Combat Royale",
        category: "Evento",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-12.jpg",
        meta: "Diciembre 05, 2020"
    },
    {
        title: "20+ Nuevos juegos agregados",
        category: "General",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-10.jpg",
        meta: "Octubre 01, 2020"
    },
    {
        title: "Week'nd Winners",
        category: "Evento",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-7.jpg",
        meta: "Diciembre 16, 2020"
    }
]

export const News = [
    {
        title: "Week'nd Winners",
        category: "Evento",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-7.jpg",
        meta: "Diciembre 16, 2020"
    },
    {
        title: "Próximo Combat Royale",
        category: "Evento",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-12.jpg",
        meta: "Diciembre 05, 2020"
    },
    {
        title: "20+ Nuevos juegos agregados",
        category: "General",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-10.jpg",
        meta: "Octubre 01, 2020"
    },
    {
        title: "Week'nd Winners",
        category: "Evento",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-7.jpg",
        meta: "Diciembre 16, 2020"
    },
    {
        title: "Próximo Combat Royale",
        category: "Evento",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-12.jpg",
        meta: "Diciembre 05, 2020"
    },
    {
        title: "20+ Nuevos juegos agregados",
        category: "General",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-10.jpg",
        meta: "Octubre 01, 2020"
    },
    {
        title: "20+ Nuevos juegos agregados",
        category: "General",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-10.jpg",
        meta: "Octubre 01, 2020"
    },
    {
        title: "Week'nd Winners",
        category: "Evento",
        media: "https://overworld.qodeinteractive.com/wp-content/uploads/2019/10/blog-pinterest-img-7.jpg",
        meta: "Diciembre 16, 2020"
    },
]

export const TopPlayers = [
    {
        name: "PlayerA",
        media: "/img/players/01.png",
        wins: 85,
        level: "Pro"
    },
    {
        name: "PlayerZ",
        media: "/img/players/02.png",
        wins: 73,
        level: "Pro"
    },
    {
        name: "PlayerX",
        media: "/img/players/03.png",
        wins: 62,
        level: "Legend"
    },
    {
        name: "PlayerC",
        media: "/img/players/04.png",
        wins: 45,
        level: "Pro"
    },
    {
        name: "PlayerY",
        media: "/img/players/05.png",
        wins: 22,
        level: "Explorer"
    },
]